import { Box, Stack, Typography } from '@mui/material';
import CollectionsIcon from '@mui/icons-material/Collections';
import { IconTile } from '../../../shared/components/IconTile';
import type { Document, DocumentSection, DocumentVisualization } from '../../../core/types/data-models';
import { VisualViewCard } from './VisualViewCard';

/** "Visual Artifact Views" block — a gallery of every visualization generated across the project's documents. */
export function VisualViewsSection({
  visualizations,
  docById,
  sectionById,
  onOpen,
}: {
  visualizations: DocumentVisualization[];
  docById: Map<number, Document>;
  sectionById: Map<number, DocumentSection>;
  onOpen: (viz: DocumentVisualization) => void;
}) {
  if (visualizations.length === 0) return null;

  return (
    <Box>
      <Stack direction="row" spacing={1.25} alignItems="center" sx={{ mb: 2 }}>
        <IconTile icon={<CollectionsIcon fontSize="inherit" />} color="cyan" size="sm" />
        <Box>
          <Typography variant="subtitle2" fontWeight={700} lineHeight={1.2}>
            Visual Artifact Views
          </Typography>
          <Typography variant="caption" color="text.secondary">
            Generated diagrams and visualizations
          </Typography>
        </Box>
      </Stack>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: {
            xs: 'repeat(2, 1fr)',
            sm: 'repeat(3, 1fr)',
            md: 'repeat(4, 1fr)',
            lg: 'repeat(6, 1fr)',
          },
          gap: 2,
        }}
      >
        {visualizations.map((viz) => {
          const section = viz.documentSectionId != null ? sectionById.get(viz.documentSectionId) : undefined;
          return (
            <VisualViewCard
              key={viz.id}
              viz={viz}
              docName={docById.get(viz.documentId)?.name}
              sectionTitle={section?.title}
              onClick={() => onOpen(viz)}
            />
          );
        })}
      </Box>
      <Box sx={{ height: 64 }} />
    </Box>
  );
}
